export default "__VITE_ASSET__28f550b3__"